import { render, staticRenderFns } from "./TableProductPromotionList.vue?vue&type=template&id=3e77ab28&scoped=true&"
import script from "./TableProductPromotionList.vue?vue&type=script&lang=js&"
export * from "./TableProductPromotionList.vue?vue&type=script&lang=js&"
import style0 from "./TableProductPromotionList.vue?vue&type=style&index=0&id=3e77ab28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e77ab28",
  null
  
)

export default component.exports